import { render, staticRenderFns } from "./modal-plan-purchase.vue?vue&type=template&id=bcc8a3a8&"
import script from "./modal-plan-purchase.vue?vue&type=script&lang=js&"
export * from "./modal-plan-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports